import request from "../../request.js"
import qs from "qs";
// 行程表
export  function getFxxkDingItineraryStatistic(data) {
	return request({
		url: "/fxxk-ding-itinerary/getFxxkDingItineraryStatistic",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 行程表-编辑
export  function updateFxxkDingItinerarySub(data) {
	return request({
		url: "/fxxk-ding-itinerary-sub/updateFxxkDingItinerarySub",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 行程表-重置
export  function updateFxxkDingItinerarySubDataSignReset(data) {
	return request({
		url: "/fxxk-ding-itinerary-sub/updateFxxkDingItinerarySubDataSignReset",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 行程表更新时间
export  function getFxxkDingItinerarySubUpdateByDate(data) {
	return request({
		url: "/fxxk-ding-itinerary-sub-update/getFxxkDingItinerarySubUpdateByDate",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 登录
export  function doFxxkDingUserLogin(data) {
	return request({
		url: "/fxxk-ding-user/doFxxkDingUserLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 登录-刷新
export  function getFxxkDingUserAuth(data) {
	return request({
		url: "/fxxk-ding-user/getFxxkDingUserAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉用户
export  function getFxxkDingUserList(data) {
	return request({
		url: "/fxxk-ding-user/getFxxkDingUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉部门
export  function getFxxkDingDepartmentList(data) {
	return request({
		url: "/fxxk-ding-department/getFxxkDingDepartmentList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉用户编辑
export  function updateFxxkDingUserAuth(data) {
	return request({
		url: "/fxxk-ding-user/updateFxxkDingUserAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉用户重置密码
export  function updateFxxkDingUserPw(data) {
	return request({
		url: "/fxxk-ding-user/updateFxxkDingUserPw",
		method: "POST",
		data:qs.stringify(data)
	})
}
//行程表-行用户数据查询
export  function getFxxkDingUserAuthRowList(data) {
	return request({
		url: "/fxxk-ding-user-auth-row/getFxxkDingUserAuthRowList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//行程表-行用户数据编辑
export  function updateFxxkDingUserAuthRow(data) {
	return request({
		url: "/fxxk-ding-user-auth-row/updateFxxkDingUserAuthRow",
		method: "POST",
		data:qs.stringify(data)
	})
}
//行程表-行用户数据详情
export  function getFxxkDingUserAuthRowDetails(data) {
	return request({
		url: "/fxxk-ding-user-auth-row/getFxxkDingUserAuthRowDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//行程表-列数据查询
export  function getFxxkDingUserAuthColList(data) {
	return request({
		url: "/fxxk-ding-user-auth-col/getFxxkDingUserAuthColList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//行程表-列数据编辑
export  function updateFxxkDingUserAuthCol(data) {
	return request({
		url: "/fxxk-ding-user-auth-col/updateFxxkDingUserAuthCol",
		method: "POST",
		data:qs.stringify(data)
	})
}
//行程表列表获取筛选表头
export  function getFxxkDingItineraryStatisticHeaderSelected(data) {
	return request({
		url: "/fxxk-ding-itinerary/getFxxkDingItineraryStatisticHeaderSelected",
		method: "POST",
		data:qs.stringify(data)
	})
}